/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MotorTorqueCurvesData } from './MotorTorqueCurvesData';
/**
 * Motor in Database.
 */
export type MotorTorqueCurvesInDB = {
    item_type?: MotorTorqueCurvesInDB.item_type;
    name?: string;
    mass?: number;
    moment_of_inertia?: number;
    cost?: number;
    component_type?: 'MotorTorqueCurves';
    torque_curves: MotorTorqueCurvesData;
    _id?: string;
};
export namespace MotorTorqueCurvesInDB {
    export enum item_type {
        COMPONENT = 'component',
    }
}

